import React from "react";
import PollAnswer from './PollAnswer';
import { PollReducer } from './PollReducer';
import axios from "axios";
import URL from "../../common/variables";
import { isActiveToken, axiosHeadersConfig } from "./../../common/functions";

class Poll extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loggedIn: isActiveToken(),
            loading: true,
            hasVoted: false,
        };
    }

    componentDidMount() {
        let config;

        if (isActiveToken()) {
            config = axiosHeadersConfig();
        } else {
            config = {};
        }

        axios.get(`${URL}/polls/latest/`, config).then((res) => {
            this.setState(PollReducer(this.state, {
                type: 'LOAD_POLL',
                poll: res.data,
            }));
        });
    }

    handleClick(choice) {
        if (!isActiveToken()) {
            return;
        }

        if(this.state.hasVoted) {
            return;
        }

        const config = axiosHeadersConfig();

        axios.post(`${URL}/polls/${this.state.poll.id}/vote/`, {
            choice: choice.id,
        }, config)
            .then((res) => {
                const state = PollReducer(this.state, {
                    type: 'NEW_VOTE',
                    choice: res.data.choice,
                });

                this.setState(state);
            })
            .catch(() => {
                this.setState(PollReducer(this.state, {
                    type: 'VOTE_REJECTED',
                }));
            });
    }

    render() {
        let content;

        let loggedInMessage = <>Queremos saber tu opinión.<br/>Vota dando click en la respuesta que más te parezca</>;
        let notLoggedInMessage = <>Queremos saber tu opinión.<br/><a href="/pages/perfil/">Inicia sesión</a> para votar en esta encuesta</>

        if (this.state.loading) {
          content = (<div className="poll-loader">Cargando...</div>);
        } else {
          content = (
            <div className={"poll-inner " + (this.state.loggedIn ? '':'poll-anonymous')}>
              <div className="poll-question">
                <p className="question">{this.state.poll.text}</p>
                <div className="instructions">{this.state.loggedIn ? loggedInMessage : notLoggedInMessage}</div>
              </div>
              <div className="poll-answers">
                {this.state.poll.choices.map((c) => {
                    let percentage;
                    if (this.state.poll.vote_count == 0) {
                        percentage = 0;
                    } else {
                        percentage = c.vote_count/this.state.poll.vote_count*100;
                    }

                    return (<PollAnswer text={c.choice} percentage={percentage} key={c.id} hasCount={c.vote_count !== undefined} onClick={() => this.handleClick(c)} />)
                })}
              </div>
            </div>
          );
        }

        return (
            <div className="titled-box box-h6 box-left box-sans box-compact poll">
              <div className="box-title">
                <h6>
                  <i className="fas fa-align-left"></i>&nbsp;&nbsp; Encuesta del día
                </h6>
              </div>
              <div className="yellow underline"></div>
              <div className="box-body">
                {content}
              </div>
            </div>
        );
    }
};

export default Poll;
